import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import {
  useUpdateCart,
  UpdateCartData,
  UpdateCartProps,
} from "src/hooks/useUpdateCart";
import { ExecutionResult } from "graphql";
import { CartInfo } from "src/types/cartInfo";

interface AddDiscountCodeToCartHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  updateCartCustomField: (
    name: string,
    value: string,
    cartInfo: CartInfo
  ) => Promise<ExecutionResult<UpdateCartData> | undefined>;
}

function useUpdateCartCustomField({
  refetchQueries = [],
  onCompleted,
  onError,
}: UpdateCartProps = {}): AddDiscountCodeToCartHook {
  const { updateCart, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
    onError,
  });

  const updateCartCustomField: AddDiscountCodeToCartHook["updateCartCustomField"] =
    useCallback(
      async (name, value, cartInfo) => {
        return await updateCart({
          cartInfo,
          actions: [
            {
              setCustomField: {
                name,
                value,
              },
            },
          ],
        });
      },
      [updateCart]
    );

  return { updateCartCustomField, loading, error };
}

export { useUpdateCartCustomField };
